import Button from "../button/button.component";
import birdPhoto from "../../assets/bird.png";
import "./navbar.component.css";
import { useEffect, useState } from "react";

export const NavLink = {
  HOME: "home",
  ABOUT_ME: "about-me",
  CASE_STUDY: "case-study",
  SOCIALS: "socials",
};

function Navbar() {
  const [activeLink, setActiveLink] = useState(() => {
    return localStorage.getItem("activeLink") || "Home";
  });

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const links = [
    { name: "Home", id: NavLink.HOME },
    { name: "Case Study", id: NavLink.CASE_STUDY },
    { name: "About Me", id: NavLink.ABOUT_ME },
  ];

  const handleLinkClick = (link) => {
    if (link.id === NavLink.HOME) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      const section = document.getElementById(link.id);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }

    setTimeout(() => {
      setActiveLink(link.name);
      localStorage.setItem("activeLink", link.name);
    }, 300);

    setIsMenuOpen(false);
  };

  const scrollToSocials = () => {
    const section = document.getElementById(NavLink.SOCIALS);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    const observerOptions = {
      root: null,
      threshold: 0.6,
    };

    let debounceTimeout;

    const observerCallback = (entries) => {
      clearTimeout(debounceTimeout);
      debounceTimeout = setTimeout(() => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const link = links.find((l) => l.id === entry.target.id);
            if (link) {
              setActiveLink(link.name);
              localStorage.setItem("activeLink", link.name);
            }
          }
        });
      }, 100);
    };

    const observer = new IntersectionObserver(
      observerCallback,
      observerOptions
    );

    links.forEach((link) => {
      const section = document.getElementById(link.id);
      if (section) {
        observer.observe(section);
      }
    });

    return () => {
      links.forEach((link) => {
        const section = document.getElementById(link.id);
        if (section) {
          observer.unobserve(section);
        }
      });
      clearTimeout(debounceTimeout);
    };
  }, [links]);

  return (
    <div className="d-flex col-12 align-items-center justify-content-space-between gray-back rounded-pill px-3 py-2 sub-font-1">
      <div className="d-flex align-items-center fs-3 font-bold sub-font-1">
        <img className="bird" src={birdPhoto} alt="logo" />
        Tshepiso.M
      </div>

      <div className="links d-none d-md-flex">
        {links.map((link) => (
          <div
            key={link.id}
            className={`link ${activeLink === link.name ? "active" : ""}`}
            onClick={() => handleLinkClick(link)}
          >
            {link.name}
          </div>
        ))}
      </div>

      {/* Burger Menu Icon */}
      <div
        className="d-md-none burger-menu"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
      >
        <div className="burger-line"></div>
        <div className="burger-line"></div>
        <div className="burger-line"></div>
      </div>

      {/* Burger Menu Dropdown */}
      {isMenuOpen && (
        <div className="burger-dropdown">
          {links.map((link) => (
            <div
              key={link.id}
              className={`burger-link ${
                activeLink === link.name ? "active" : ""
              }`}
              onClick={() => handleLinkClick(link)}
            >
              {link.name}
            </div>
          ))}
        </div>
      )}

      <div className="d-none d-md-flex connect">
        <Button text="Connect" isDark={true} onClick={scrollToSocials} />
      </div>
    </div>
  );
}

export default Navbar;
